module.exports = __webpack_public_path__ + "img/production-w.effff8c9.svg";